import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { Button, Card, CardContent, CardHeader, Icon } from '@material-ui/core';
import CustomizedTextField from '../../components/Input/CustomizedTextField';
import moment from 'moment';
import InterventionStatusIcon from '../../components/Interventions/Extranet/InterventionStatusIcon';
import { formatStatus } from '../../redux/intervention/extranetInterventionStatus';
import InterventionDetails from '../../components/Interventions/Extranet/InterventionDetails';
import Invoices from '../Invoices/Invoices';
import { clearIntervention } from '../../redux/intervention/extranetInterventionActions';
import { loadAffair } from '../../redux/affair/affairActions';
import InterventionAttachments from '../../components/Interventions/Extranet/InterventionAttachments';

class ExtranetIntervention extends Component {

    constructor(props) {
        super(props);

        if (!props.intervention)
            this.props.history.push("/interventions");
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.history.push("/interventions");
    }

    componentWillUnmount() {
        this.props.clearIntervention();
    }

    onAffairClick() {
		this.props.loadAffair(this.props.intervention.affair_id);
		this.props.history.push("/affairs/affair");
		this.props.globalStore.container.current.scrollTop = 0
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.intervention) return null;

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={"Détails d'intervention"}
                        titleTypographyProps={{ variant: "h4", color: 'primary' }} />
                    <CardContent className="row without-side-padding-only-small-screen">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={moment(this.props.intervention.date_planned_start).format("DD/MM/YYYY HH:mm")}
                                id="date"
                                label="Date"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.name}
                                id="name"
                                label="Numéro"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.failure_description}
                                id="Description"
                                label="Description"
                                multiline
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.allocation_label}
                                id="Type"
                                label="Type"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                InputProps={{
                                    startAdornment: (
                                        <InterventionStatusIcon
                                            state={this.props.intervention.state}
                                        />
                                    ),
                                }}
                                value={formatStatus(
                                    this.props.intervention.state
                                )}
                                id="status"
                                label="Statut"
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        {this.props.intervention.real_begin_date ? (
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <CustomizedTextField
                                    value={moment(this.props.intervention.real_begin_date).format("DD/MM/YYYY HH:mm")}
                                    id="real_begin_date"
                                    label="Date de début réel"
                                    className="full_size light-disabled control-margin-top"
                                />
                            </div>
                        ) : null}
                        {this.props.intervention.real_end_date ? (
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <CustomizedTextField
                                    value={moment(this.props.intervention.real_end_date).format("DD/MM/YYYY HH:mm")}
                                    id="real_end_date"
                                    label="Date de fin réelle"
                                    className="full_size light-disabled control-margin-top"
                                />
                            </div>
                        ) : null}
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <CustomizedTextField
                                value={this.props.intervention.report_overview}
                                id="report_overview"
                                label="Rapport général"
                                multiline
                                className="full_size light-disabled control-margin-top"
                            />
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12 row">
                            <CustomizedTextField
                                value={this.props.intervention.affair_id ? "[" + this.props.intervention.affair_id.code + "] " + this.props.intervention.affair_id.name : ""}
                                id="affair"
                                label="Affaire"
                                className="full_size light-disabled control-margin-top col-lg-10 col-md-10 col-sm-10 col-9 without-side-padding"
                            />
                            <div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-3 control-inline-btn">
                                <Button
                                    className="div-center"
                                    variant="contained"
                                    size="small"
                                    onClick={this.onAffairClick.bind(this)}
                                >
                                    <Icon>folder</Icon>
                                </Button>
                            </div>
                        </div>
                    </CardContent>
                </Card>
                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={"Equipement(s) concerné(s)"} titleTypographyProps={{ variant: "h5", color: 'primary' }} />
                    <CardContent className="without-side-padding-only-small-screen">
                        <InterventionDetails intervention={this.props.intervention} />
                    </CardContent>
                </Card>
                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={"Pièces jointes du rapport"} titleTypographyProps={{ variant: "h5", color: 'primary' }} />
                    <CardContent className="without-side-padding-only-small-screen">
                        <InterventionAttachments intervention={this.props.intervention} />
                    </CardContent>
                </Card>
                <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                    <CardHeader title={"Facture(s) associée(s) à l'affaire"} titleTypographyProps={{ variant: "h5", color: 'primary' }} />
                    <CardContent className="without-side-padding-only-small-screen">
                        <Invoices {...this.props} withoutFilters />
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        intervention: state.extranetIntervention.currentIntervention,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearIntervention: () => dispatch(clearIntervention()),
		loadAffair: (affair) => dispatch(loadAffair(affair)),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(ExtranetIntervention);
